/** Zoom horizontal fijo del carril (mástil / highway) en px por unidad de pulso. */
export const DEFAULT_SONG_VIEW_PIXELS_PER_BEAT = 140;

/** Relleno superior del pentagrama (más arriba en el lienzo de aprendizaje). */
export const DEFAULT_SONG_VIEW_STAFF_TOP_PADDING_PX = 20;

/** Relleno superior fijo sobre el mástil (Song Studio). */
export const DEFAULT_SONG_VIEW_HIGHWAY_TOP_PADDING_PX = 24;

/** +40 % de presencia visual del pentagrama en Canciones. */
export const SONG_STAFF_GROWTH = 1.4;

const SONG_STAFF_BASE_SCALE = 1.4;
const SONG_STAFF_BASE_HEIGHT = 260;

export const SONG_STAFF_STAVE_SCALE = SONG_STAFF_BASE_SCALE * SONG_STAFF_GROWTH;
export const SONG_STAFF_HEIGHT_PX = Math.round(SONG_STAFF_BASE_HEIGHT * SONG_STAFF_GROWTH);
